import FormGroup from 'erxes-ui/lib/components/form/Group';

export default FormGroup;
